<template>
    <v-dialog :model-value="show"
              :persistent="true"
    >
        <v-card :rounded="true"
                :bored="true"
                :flat="true"
                :border="true"
        >
            <v-card-title class="d-flex align-center">
                <v-icon icon="mdi-rocket-launch" color="primary" class="mr-2" />
                New Features Released!
            </v-card-title>
            <v-card-subtitle>
                Version {{ release_notes.version }}
            </v-card-subtitle>
            <v-card-subtitle class="mb-5">
                Released: {{ DateManager.formatUnix(release_notes.released_at, 'MMMM DD, YYYY') }}
            </v-card-subtitle>
            <v-divider />
            <v-card-text class="pa-5">
                <div v-html="parsedNotes" />
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-spacer />
                <v-btn color="primary"
                       @click="onContinue"
                       prepend-icon="mdi-check"
                >
                    Continue
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script setup>
    import {storeToRefs} from 'pinia';
    import {useMainStore} from '@/store';
    import {marked} from 'marked';
    import {computed} from "vue";
    import DateManager from "@/services/dateManager";

    defineProps({
        show: {
            type: Boolean,
        },
    });

    const store = useMainStore();
    const {release_notes} = storeToRefs(store);

    const parsedNotes = computed(() => marked.parse(release_notes.value.notes ?? ''));

    function onContinue() {
        store.RESET_PROPERTY('release_notes');
    }
</script>